import React, { memo, useContext } from "react";
import { Navigate, NavLink, useLocation, useParams } from "react-router-dom";
import routes from "../routes";
import { UserContext } from "../context/User.context";
import { roles, rolesAccess } from "../../utils/constants";
import { isFunction } from "webpack-merge/dist/utils";
import { useDispatch, useSelector } from "react-redux";
import { isRouteDisabled, visibilityOnRoute } from "./navigationHelper";
import { clearPrestation } from "../../pages/Prestations/Slices/Prestation.slice";

// Wraooer to check only if the User is connected or not
function AuthRoute({ children, ...rest }) {
  const location = useLocation();

  const { isConnected, appReady } = useContext(UserContext);

  return (
    <>{isConnected ? children : <Navigate to={"/auth"} replace={true} />}</>
  );
}

// Return the level access from a role
const getLevelAccess = role => {
  return rolesAccess[roles[role]];
};

// Return a boolean if this user can see or access this route
export const userHasLevel = (rule = null, action = "r") => {
  let exemple = {
    all: Number,
    only: Object,
    not: Object,
    // limited: Array, -> will be on backend sides
  };

  // Contexte
  const { user } = useContext(UserContext);

  // Level acces of user
  let level = getLevelAccess(user.role);

  if (rule === null) {
    // Not ready or no imformation
    return true;
  }

  if (rule.only && rule.not) {
    console.error("You can either pick only or not");
    return undefined;
  }

  // init var
  let hasLevel = false;

  if (rule.all) {
    // Manage route with all access and ranking
    // Simpler and give all access
    hasLevel = level >= rule.all;
  } else if (rule.only || rule.not) {
    let rolesMatching = userRolesInObject(user, rule.only || rule.not);

    let rolesIncluded = rolesMatching.some(e => e.includes(action));

    if (rule.only) {
      // Get the role Matching and find if one of them has the r
      const hasARoleToRead = rolesMatching.find(roleMatched => {
        return rule.only[roleMatched].includes(action);
      });

      hasLevel = hasARoleToRead !== undefined;
    } else if (rule.not) {
      if (rolesMatching.length > 0) {
        hasLevel = false;
      } else {
        hasLevel = true;
      }
    }
  } else {
    hasLevel = true;
  }

  return hasLevel;
};

export const RestrictedRoute = ({ children, redirect = true, route }) => {
  const { id } = useParams();
  const dispatch = useDispatch();

  const { prestation, loading, ready, dangerousUpdate } = useSelector(
    state => state.prestation,
  );

  const access = userHasLevel(route);

  const resetPrestation = async () => {
    await dispatch(clearPrestation());
  };



  if (
    ready &&
    (visibilityOnRoute({ id, prestation, child: route, dangerousUpdate }) ||
      isRouteDisabled({ id, prestation, child: route, dangerousUpdate }))
  ) {
    resetPrestation();
    if (route.fallBack !== undefined && isFunction(route.fallBack)) {
      return <Navigate to={route?.fallBack(id)} replace={true} />;
    } else {
      return <DefaultRouteRole />;
    }
    // redirect out of the page if this is a new pattern
  } else if (access) {
    // Clone the original element and add/modify props
    const childrenWithRoute = React.cloneElement(children, {
      route,
    });

    // return loading ? "loading" : childrenWithRoute;
    return childrenWithRoute;
  } else {
    if (route.fallBack !== undefined && isFunction(route.fallBack)) {
      return <Navigate to={route?.fallBack(id)} replace={true} />;
    } else {
      return <DefaultRouteRole />;
    }
  }
};

AuthRoute.propTypes = {};

export const NavLinkCustom = ({ route }) => {
  if (userHasLevel(route)) {
    return (
      <NavLink
        to={route.path}
        style={({ isActive, isPending }) => {
          return {
            //color: isActive ? 'red' : 'inherit',
          };
        }}
        className={({ isActive, isPending }) => {
          return isActive ? "active menuLink" : "menuLink ";
        }}
      >
        {route.title}
      </NavLink>
    );
  } else {
    return null;
  }
};

// For a given only rules return the matching role of this user
const userRolesInObject = (user, only) => {
  let rolesMatching = [];

  const onlyRole = only[user.role];

  user.subRoles.map(subRole => {
    if (only[subRole]) {
      rolesMatching.push(subRole);
    }
  });

  if (onlyRole !== undefined) {
    rolesMatching.push(user.role);
  }

  return rolesMatching;
};

export const onlyRoles = ({ only }) => {
  const { user } = useContext(UserContext);

  return true;
};

const UserCanDoAction = ({ route, action, children }) => {
  const hasLevel = userHasLevel(route, action);

  if (hasLevel) {
    return children;
  } else {
    return null;
  }
};

UserCanDoAction.areEqual = (prevProps, nextProps) => {
  return false;
};

// return Bool
export const onlyRoleMapping = only => {
  const { user } = useContext(UserContext);

  if (
    typeof only === "object" &&
    !Array.isArray(only) &&
    only !== null &&
    typeof only === "string"
  ) {
    // Object, split it
  }

  if (Array.isArray(only)) {
    let roleMatching = only.includes(user.role);
    let subroleMatching = user.subRoles.some(subRole => only.includes(subRole));

    return roleMatching || subroleMatching;
  } else {
    let roleMatching = only === user.role;
    let subroleMatching = user.subRoles.includes(only);

    return roleMatching || subroleMatching;
  }
};

export const ActionRoleSpecific = ({ only, children }) => {
  return onlyRoleMapping(only) ? children : null;
};

export const UserHasLevel = ({ action, rule, children }) => {
  const hasLevel = userHasLevel(rule, action);
  if (hasLevel) {
    return children;
  } else {
    return null;
  }
};

export const UserCanDoActionMemo = memo(
  UserCanDoAction,
  UserCanDoAction.areEqual,
);

export const DefaultRouteRole = () => {
  const { user } = useContext(UserContext);

  const location = useLocation();

  switch (user.role) {
    case roles.admin:
    case roles.mandant:
    case roles.permanance:
    case roles.institution:
      return <Navigate to={routes.prestations().list.path} replace={true} />;

    // case roles.institution:
    //   return (
    //     <Navigate
    //       to={routes.institutions(user?.institution).detail.path}
    //       replace={true}
    //     />
    //   );
    case roles.interprete:
      // return (
      //   <Navigate
      //     to={routes.interpretes(user._id).detail.path} // buggy i dont know why
      //     replace={true}
      //   />
      // );
      return <Navigate to={routes.prestations().list.path} replace={true} />;

    case roles.ghost:
      return <Navigate to={routes.auth().path} replace={true} />;
  }
};

export default AuthRoute;
